import {observer_mgl} from "mobx-graphlink";
import React, {useState} from "react";
import {Button, Column, Row, Text} from "react-vcomponents";
import {ES, RunInAction_Set} from "web-vcore";
import {GuideShape} from "../../../../Server/DB/mapObjects/@MapObject/ObjMesh.js";
import {InterpolateConfig, ObjPath, PathTransform} from "../../../../Server/DB/mapObjects/@MapObject/ObjPath.js";
import {Vec2} from "../../../../Utils/ThreeJS/VectorStructs.js";
import {PropertiesUI_SharedProps} from "../PropertiesUI.js";
import {PathEditorUI} from "./Paths/PathEditorUI.js";

export const Paths_CompUI = observer_mgl((props: {} & PropertiesUI_SharedProps)=>{
	const {map, mapState, obj, Change} = props;
	const objPaths = obj.paths ?? [];

	const uiState = mapState.propertiesPanel;
	// Set12 P7 — the selected path index is persisted on the PropertiesPanelState so the
	// terrain-materials modifier's region overview can jump to a path (sets `paths_selectedIndex`
	// + `path_tab`).  Falls back to 0 (KeepBetween clamps when the list shrinks).
	const [selectedPathIndex, setSelectedPathIndex] = useState(uiState.paths_selectedIndex);
	const selectedPathIndex_final = selectedPathIndex.KeepBetween(0, objPaths.length - 1);
	const setSelectedPathIndexFinal = (index: number)=>{
		setSelectedPathIndex(index);
		RunInAction_Set(()=>uiState.paths_selectedIndex = index);
	};

	return (
		<Column>
			<Row>
				<Text>Paths:</Text>
				<Row style={{flexWrap: "wrap", gap: 5, marginLeft: 5}}>
					{objPaths.map((path, index)=>{
						return <Button key={index} p="2px 5px" text={`#${index + 1}`}
							style={ES(
								selectedPathIndex_final == index && {backgroundColor: "rgba(100,200,100,.5)"},
							)}
							onClick={()=>setSelectedPathIndexFinal(index)}/>;
					})}
					<Button mdIcon="plus" onClick={()=>{
						const newPath = new ObjPath({
							path_id: ObjPath.NewPathID(),
							texture_size: new Vec2(1, 1),
							points: [],
							guide_shape: GuideShape.square,
							guide_size: 0.5, // 1m is too large; 0.5 is better, without having >1 decimal point (could also do 0.1 or something I guess)
							guide_alignPoints: true,
							// Default to a catmullRom interpolate transform (the pre-refactor default was
							// curveType=catmullRom). The Catmull-Rom params live directly on InterpolateConfig
							// now (flattened 2026-08-02); an empty config gives the legacy defaults
							// (centripetal, tension 0.5, 10 points/segment, no fBm layer).
							transforms: [
								new PathTransform({interpolate: new InterpolateConfig({})}),
							],
						});
						Change(a=>a.paths = (a.paths ?? []).concat(newPath));
					}}/>
				</Row>
			</Row>
			{selectedPathIndex_final <= objPaths.length - 1 &&
			<PathEditorUI key={selectedPathIndex_final} {...{map, mapState, obj, index: selectedPathIndex_final, Change}}/>}
		</Column>
	);
});